import React from "react"
import { Route } from "react-router-dom"
import PropTypes from "prop-types"

class TabNavSubSectionContainer extends React.Component {
  componentDidMount = async () => {
    try {
      await this.props.onEnter()
    } catch (error) {
      //TODO
    }
  }

  componentWillUnmount = async () => {
    try {
      await this.props.onExit()
    } catch (error) {
      //TODO
    }
  }

  render = () => this.props.component()
}

const TabNavSubSection = ({
  name,
  title,
  component,
  section,
  onEnter,
  onExit
}) => (
  <Route
    path={`/${section}/${name}`}
    render={() => (
      <TabNavSubSectionContainer
        component={component}
        onEnter={onEnter}
        onExit={onExit}
      />
    )}
  />
)

TabNavSubSection.displayName = "TabNavSubSection"

TabNavSubSection.propTypes = {
  skip: PropTypes.func
}

TabNavSubSection.defaultProps = {
  skip: () => false
}
export default TabNavSubSection
